export const hourlyRatesByUserId = state => id => _.filter(state.historicalData.items, {reference_id: parseInt(id), field: 'hourly_rate'})